import { ComponentProps, forwardRef } from "react";
import { tabClasses, TabVariants } from "./Tab.style";
import { Tabs as BaseTab } from "@base-ui-components/react/tabs";
import { useMediaQuery } from "@/hooks";
import Option from "@/Option";

export type TabProps = ComponentProps<typeof BaseTab.Tab> & TabVariants;

const Tab = forwardRef<HTMLButtonElement, TabProps>((props, ref) => {
  const { className, value, ...rest } = props;
  const isMobile = useMediaQuery("sm");

  return (
    <BaseTab.Tab
      ref={ref}
      className={tabClasses({
        className: typeof className === "string" ? className : "",
      })}
      render={({ className, ...others }) => {
        return isMobile ? (
          <Option {...others} value={value} />
        ) : (
          <button className={className} {...others} />
        );
      }}
      value={value}
      {...rest}
    />
  );
});
Tab.displayName = "Tab";
export default Tab;
